<template>
  <section
    class="accordion-container"
    :class="[`${dataKey}-accordion`, { fullscreen: isFullscreen }]"
  >
    <div v-if="accordionLine(dataKey)" class="accordion-top-line"></div>
    <div class="list-container" :class="{ handle: true }">
      <!-- :class="{'handle' : !useDevice().isMobile}" -->
      <div v-if="lightDarkMode" class="light-dark-mode">
        <div
          :class="['moon', { active: currentMode === 'dark' }]"
          @click="handleLightDarkMode('dark', dataKey)"
        >
          <img
            :src="
              currentMode === 'dark'
                ? require('@/assets/images/icons/moon_black.svg')
                : require('@/assets/images/icons/moon_blue.svg')
            "
            alt="moon"
          />
        </div>
        <div
          :class="['sun', { active: currentMode === 'light' }]"
          @click="handleLightDarkMode('light', dataKey)"
        >
          <img
            :src="
              currentMode === 'light'
                ? require('@/assets/images/icons/sun_black.svg')
                : require('@/assets/images/icons/sun_blue.svg')
            "
            alt="sun"
          />
        </div>
      </div>
      <img
        v-if="lightDarkMode"
        src="@/assets/images/icons/light_dark_mode_line.png"
        alt=""
        class="light-dark-mode-line"
      />
      <img class="img" :src="icon" :style="iconStyle" />
      <h2
        v-if="dataKey == 'alpha'"
        class="title highlight"
        style="display: flex; align-items: center; gap: 0.5rem"
      >
        <template v-if="isMobile">
          {{ title }} <br />
          {{ $t("menu.alphaChart") }}
        </template>
        <template v-else>
          {{ title }}
          {{ $t("menu.alphaChart") }}
        </template>
      </h2>
      <h2
        v-else-if="dataKey != 'meta' && strategyTitle"
        class="title highlight"
        style="display: flex; align-items: center; gap: 0.5rem"
      >
        <template v-if="isMobile">
          {{ title }} <br />
          {{ strategyTitle }} Chart
        </template>
        <template v-else> {{ title }} {{ strategyTitle }} Chart </template>
      </h2>
      <h2
        v-else-if="dataKey != 'meta'"
        class="title highlight"
        v-html="title"
      ></h2>
      <h2
        v-else
        class="title highlight"
        style="display: flex; align-items: center; gap: 0.5rem"
      >
        <template v-if="isMobile">
          {{ title }} <br />
          {{ $t("chart1.metaChart") }}
          <span style="font-size: 1.7rem"
            >- {{ $t("kibot.grid.futures") }}</span
          >
        </template>
        <template v-else>
          {{ title }}
          {{ $t("chart1.metaChart") }}
          <span style="font-size: 1.7rem"
            >- {{ $t("kibot.grid.futures") }}</span
          >
        </template>
      </h2>
      <img
        v-if="tooltipMsg"
        src="@/assets/images/icons/tooltip-ico2.svg"
        alt=""
        v-tooltip.top-start="tooltipMsg"
        class="tooltip-ico"
        @click="showPopup(viewPage, dataKey)"
      />
      <span v-if="props.badge" class="badge">{{ props.badge }}</span>

      <!-- @touchstart="accordionClick(dataKey)" -->
      <button @click="accordionClick(dataKey)" v-if="isOpen" class="toggle-btn">
        <img
          src="@/assets/images/components/common/arrow_drop_down_circle.svg"
          alt="risingx_dropdown"
        />
      </button>
      <button @click="accordionClick(dataKey)" v-else class="toggle-btn">
        <img
          src="@/assets/images/components/common/arrow_drop_up_circle.svg"
          alt="risingx_dropdown"
        />
      </button>
    </div>

    <div class="content-conatiner">
      <slot></slot>
    </div>

    <!-- <section
      class="btn-container multi-chart-container"
      v-if="dataKey === 'meta'"
    >
      <button class="btn clear-button multi-chart" @click="chartPopupHandler">
        <span class="">{{ $t("chart1.multiChart") }}</span>
      </button>
    </section> -->
  </section>
  <UiDialogExplainContent
    :width="explainContent.width"
    :height="explainContent.height"
    :btnName="explainContent.btnName"
    :isVisible="explainContent.visible"
    :viewPage="explainContent.viewPage"
    @onDialogClose="closeCopyDialog"
  />
  <!-- <p>{{props}}</p> -->
</template>

<script setup>
import UiDialogExplainContent from "@/components/ui/dialog/ExplainContent.vue";
import { defineProps, ref, computed, watch, defineExpose } from "vue";
import { useRouter } from "vue-router";
import { useResolutionStore } from "@/store/useResolution";
import { getFavCoinListData } from "@/api/chart/coinListFavChartApi";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { template } from "lodash-es";

const resolutionStore = useResolutionStore();
const isMobile = computed(() => resolutionStore.isMobile);
const store = useStore();

watch(
  () => window.innerWidth,
  () => {
    resolutionStore.setSize({ width: window.innerWidth });
  }
);

window.addEventListener("resize", () => {
  resolutionStore.setSize({ width: window.innerWidth });
});

const props = defineProps({
  title: String,
  icon: String,
  iconStyle: Object,
  tooltipMsg: String,
  isOpen: Boolean,
  accordionList: Array,
  dataKey: String,
  viewPage: String,
  isFullscreen: Boolean,
  badge: String,
  strategyTitle: String,
  lightDarkMode: String,
  ticker: String,
});

const router = useRouter();
// console.log("router.currentRoute.value.path", router.currentRoute.value.path);
const { t, locale } = useI18n({ useScope: "global" });

function accordionClick(dataKey) {
  const isOpen = props.accordionList.find((ob) => ob.key === dataKey).open;
  // if (router.currentRoute.value.query.menuName !== dataKey) {

  // router.push({
  //   path: router.currentRoute.value.path,
  //   query: { menuName: dataKey },
  // });
  // }
  props.accordionList.find((ob) => ob.key === dataKey).open = isOpen
    ? false
    : true;
}

let explainContent = ref({
  width: isMobile.value ? "90%" : "720px",
  height: null,
  btnName: "chart1.popupClose",
  visible: false,
  viewPage: null,
});

watch(isMobile, (newValue) => {
  explainContent.value.width = newValue ? "90%" : "720px";

  if (explainContent.value.viewPage) {
    explainContent.value.height = newValue
      ? explainContent.value.viewPage.__file.includes("tradingview") ||
        explainContent.value.viewPage.__file.includes("cross") ||
        explainContent.value.viewPage.__file.includes("kibotZone") ||
        explainContent.value.viewPage.__file.includes("double")
        ? "auto"
        : "90%"
      : explainContent.value.viewPage.__file.includes("tradingview") ||
        explainContent.value.viewPage.__file.includes("score") ||
        explainContent.value.viewPage.__file.includes("dominance") ||
        explainContent.value.viewPage.__file.includes("after") ||
        explainContent.value.viewPage.__file.includes("cross") ||
        explainContent.value.viewPage.__file.includes("kibotZone") ||
        explainContent.value.viewPage.__file.includes("double")
      ? "auto"
      : "90%";
  }
});

const accordionLine = (dataKey) => {
  const includeItem = ["dominance"];
  return includeItem.includes(dataKey);
};

// 팝업
const showPopup = (viewPage, dataKey) => {
  explainContent.value.viewPage = viewPage;
  explainContent.value.name = viewPage;

  // showPopup 안에서 직접 height 값을 재설정
  explainContent.value.height = isMobile.value
    ? dataKey?.includes("trading") ||
      dataKey?.includes("kibotZone") ||
      dataKey?.includes("cross") ||
      dataKey?.includes("double")
      ? "auto"
      : "90%"
    : dataKey?.includes("trading") ||
      dataKey?.includes("dominance") ||
      dataKey?.includes("after") ||
      dataKey?.includes("kibotZone") ||
      dataKey?.includes("cross") ||
      dataKey?.includes("double")
    ? "auto"
    : "90%";

  explainContent.value.visible = true;

  document.body.style.overflow = "hidden";
};

defineExpose({ showPopup }); // chart2.vue에서 showPopup 호출할 수 있도록 노출

const closeCopyDialog = () => {
  explainContent.value.visible = false;
  explainContent.value.viewPage = null;
  document.body.style.overflow = "";
};

let fav_coin_list = ref();

const chartPopupHandler = async () => {
  fav_coin_list.value = await getFavCoinListData();
  // const exceptList = ["BTC", "ETH", "XRP"];
  const exceptList = fav_coin_list.value;
  if (exceptList && exceptList.length > 0) {
    // router
    let url = `/popup`;
    url += `?t=${exceptList.toString()}`;
    url += `&locale=${locale.value}`;

    const options =
      "toolbar=no,scrollbars=no,resizable=yes,status=no,menubar=no,width=1200, height=800, top=0,left=0";
    window.open(url, "_blank", options);
  } else {
    store.dispatch("usePopupList/openCoinListPopup", true);
  }
};

const emit = defineEmits(["change-mode"]);

const currentMode = ref("dark");

// watch(
//   () => props.lightDarkMode,
//   (newTheme) => {
//     if (newTheme) {
//       currentMode.value = newTheme;

//       console.log(11, currentMode.value);
//     }
//   }
// );

watch(
  () => props.ticker,
  (newTicker, oldTicker) => {
    currentMode.value = "dark";
  }
);
const handleLightDarkMode = (mode, dataKey) => {
  currentMode.value = mode;
  console.log(111, mode);

  emit("change-mode", mode, dataKey);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/accordion/Accordion.scss";
.fullscreen {
  position: unset;
  backdrop-filter: unset;
}
</style>
